import { Component, OnInit, Input } from '@angular/core';
import { CategoryService } from 'src/app/services';
import { Observable } from 'rxjs';

/**
 * Message to show when the user can change the product
 *
 * @export
 * @class DirectChangeComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-direct-change',
  templateUrl: './direct-change.component.html',
  styleUrls: ['./direct-change.component.scss'],
})
export class DirectChangeComponent implements OnInit {
  /**
   * Notification background color
   *
   * @type {string}
   * @memberof DirectChangeComponent
   */
  @Input() bgColor: string = '#50e3a3';
  /**
   * Show message when the category contains direct change string
   *
   * @type {Observable<string>}
   * @memberof DirectChangeComponent
   */
  directChange$: Observable<string>;

  /**
   * Creates an instance of DirectChangeComponent.
   * @param {CategoryService} categoryService
   * @memberof DirectChangeComponent
   */
  constructor(private categoryService: CategoryService) {}

  /**
   * Listen to changes
   *
   * @memberof DirectChangeComponent
   */
  ngOnInit(): void {
    this.directChange$ = this.categoryService.directChange$;
  }
}
